import { isSessionExpired } from '@/utils/checkSessionExpired';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import Store from '../store/index';

const _isLoginRoute = () => {
  try {
    const path = window.location.pathname.replace(/\/+$/, '')
    return path === '/login'
  } catch { return false }
}

const _isPermissionDenied = (e: any) => {
  if (!e || typeof e !== 'object') return false;
  const isFirebaseError = e.name === 'FirebaseError' || e.constructor?.name === 'FirebaseError';

  if (!isFirebaseError) return false;
  return e.code === 'permission-denied' || e.message?.includes('permission-denied');
};

const _onPermissionDenied = async () => {
  try {
    const isSessionExpiredRes = await isSessionExpired();
    const isLoginRoute = _isLoginRoute()

    if (isSessionExpiredRes && !isLoginRoute) {
      console.log('SESSION HAS EXPIRED DUE TO IDLE TIMEOUT', new Date().toLocaleString())
      Store.dispatch('openSessionTimeout', true);
    }
  } catch (e) {
    console.error(e);
    window.location.assign('/login');
  }

  return;
};

export const installFirebasePermissionInterceptor = () => {
  // Catch unhandled Promise rejections (global)
  window.addEventListener('unhandledrejection', ev => {
    if (_isPermissionDenied(ev.reason)) {
      ev.preventDefault();
      _onPermissionDenied();
    }
  });

  // Patch onSnapshot for Query and DocumentReference
  const patchOnSnapshot = (Proto: any) => {
    const orig = Proto.onSnapshot;
    Proto.onSnapshot = function(...args: any[]) {
      const hasErrCb = args.length > 1 && typeof args[1] === 'function';
      const userErr = hasErrCb ? args[1] : null;
      const errCb = (err: any) => {
        if (_isPermissionDenied(err)) return _onPermissionDenied();
        if (userErr) return userErr(err);
        console.error(err);
      };
      if (hasErrCb) args[1] = errCb;
      else args.push(errCb);
      return orig.apply(this, args);
    };
  };
  patchOnSnapshot((firebase.firestore as any).Query.prototype);
  patchOnSnapshot((firebase.firestore as any).DocumentReference.prototype);

  // Patch promise-returning methods to auto-handle permission-denied
  const patchPromiseMethod = (Proto: any, name: string) => {
    const orig = Proto[name];
    if (!orig) return;
    Proto[name] = function(...args: any[]) {
      const p = orig.apply(this, args);
      return p.catch((err: any) => {
        if (_isPermissionDenied(err)) {
          _onPermissionDenied();
          return Promise.reject(err); 
        }
        throw err;
      });
    };
  };
  patchPromiseMethod((firebase.firestore as any).Query.prototype, 'get');
  patchPromiseMethod((firebase.firestore as any).DocumentReference.prototype,'get');
  patchPromiseMethod((firebase.firestore as any).DocumentReference.prototype,'set');
  patchPromiseMethod((firebase.firestore as any).DocumentReference.prototype,'update');
  patchPromiseMethod((firebase.firestore as any).DocumentReference.prototype,'delete');
  patchPromiseMethod((firebase.firestore as any).WriteBatch.prototype,'commit');
};